export const TicketsEndpoint = {
  DELETE: '/ticketing/tickets/delete',
  GET: '/ticketing/tickets/get',
  LOAD: '/ticketing/tickets/load',
  LOAD_COLUMN_SETTINGS: '/ticketing/tickets/load-column-settings',
  SAVE_COLUMN_SETTINGS: '/ticketing/tickets/save-column-settings',
  GET_ALL_BUT_DELETED_STATUS_IDS_BY_PARTNER: '/ticketing/tickets/get-all-but-deleted-status-ids-by-partner',
  GET_EDITORS: '/ticketing/tickets/get-editors',
  GET_SEARCHABLE_COLUMNS: '/ticketing/tickets/get-searchable-columns',
  GET_CAUSE_FILTER_OPTIONS: '/ticketing/tickets/get-cause-filter-options',
};
